import React from 'react';
import { Select } from 'antd';

const SelectBloodGroup = (props) => {
  return (
    <Select
      {...props}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      <Select.Option key="aPositive" value="aPositive">
        A +
      </Select.Option>
      <Select.Option key="aNegative" value="aNegative">
        A -
      </Select.Option>
      <Select.Option key="bPositive" value="bPositive">
        B +
      </Select.Option>
      <Select.Option key="bNegative" value="bNegative">
        B -
      </Select.Option>
      <Select.Option key="abPositive" value="abPositive">
        AB +
      </Select.Option>
      <Select.Option key="abNegative" value="abNegative">
        AB -
      </Select.Option>
      <Select.Option key="oPositive" value="oPositive">
        O +
      </Select.Option>
      <Select.Option key="oNegative" value="oNegative">
        O -
      </Select.Option>
    </Select>
  );
};

export default SelectBloodGroup;
